import { useTranslation } from 'react-i18next';
import { NotificationPreferencesList } from 'src/components/common/notification/preferences/list';
import { PageHeader } from 'src/components/common/page-header';

export const NotificationPreferencesPage = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'notification.preferences',
  });

  const breadCrumbsProps = {
    items: [
      { label: t('breadcrumb.settings') },
      { label: t('breadcrumb.notification-settings') },
    ],
  };

  const title = t('list.title');

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <NotificationPreferencesList />
    </>
  );
};
